module.exports = __webpack_public_path__ + "img/titleImg.c3959631.png";